module.exports = __webpack_public_path__ + "static/media/design.9a3bee67.jpg";